import React from "react";
import { DisconnectionFormValues } from "../../../../types/DisconnectionFormValues";
import { Flex } from "../../../../components/Flex";
import styled from "styled-components";
import { Span } from "../../../../components/Span";
import { getAddressInformation } from "../../../../components/LiveningIcpForm/_/LiveningIcpReviewForm/_/FormattedAddressUtil/FormattedAddressUtil";

interface Props {
  id: string;
  order: DisconnectionFormValues;
}

const LabelWrapper = styled(Span)`
  color: ${({ theme }) => theme.colors.neutrals.dn40};
  min-width: 0;
  flex-basis: 0;
`;

const ValueWrapper = styled(Span)`
  min-width: 0;
  flex-basis: 0;
`;

export const DisconnectionThankYouOrder: React.FC<Props> = ({ id, order }) => {
  return (
    <Flex flexDirection="column" id={id}>
      <Flex flexDirection="row" mb={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Installation Control Point
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${id}-icp`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {order.propertyDetails.icpAddressLookupEnabled
            ? order.propertyDetails.icpAddressLookup.id
            : "N/A"}
        </ValueWrapper>
      </Flex>

      <Flex flexDirection="row" mb={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Meter serial number
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${id}-meter-serial-number`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {order.propertyDetails.meterInfo.meterCount > 0
            ? order.propertyDetails.meterInfo.meters
                .map((value) => value.serialNumber)
                .filter((value) => value)
                .join(", ")
            : "N/A"}
        </ValueWrapper>
      </Flex>

      <Flex flexDirection="row" mb={3}>
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Site address
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${id}-address`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          {order.propertyDetails.icpAddressLookupEnabled
            ? order.propertyDetails.icpAddressLookup.label
            : getAddressInformation(
                order.propertyDetails.meterInfo.addressInformation,
              )}
        </ValueWrapper>
      </Flex>

      <Flex flexDirection="row">
        <LabelWrapper lineHeight={2} flexGrow={[0.5, 0.5, 0.5, 0.4, 0.35]}>
          Type of service
        </LabelWrapper>

        <ValueWrapper
          data-testid={`${id}-job-type`}
          lineHeight={2}
          ml={3}
          flexGrow={[0.5, 0.5, 0.5, 0.6, 0.65]}
        >
          Permanent disconnection (decommission)
        </ValueWrapper>
      </Flex>
    </Flex>
  );
};
